/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import { CheckCircleOutlined } from '@ant-design/icons';
import {
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Spin,
  Tabs,
  TimePicker,
  Typography,
} from 'antd';
import { getEstadosGlobales } from 'api/catalogos/index';
import {
  autorizarJornada,
  deleteJornada,
  getJornada,
  getJornadas,
  patchJornada,
  postJornada,
} from 'api/catalogos/jornadas';
import { getTiposJornadasNominas } from 'api/catalogos/tiposJornadasNominas';
import { checkToken } from 'api/utils';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import Table from 'components/Table';
import Moment from 'moment';
import React, { useEffect, useState } from 'react';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_INACTIVO,
} from 'utils/constants';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import { TIME_FORMAT } from 'utils/normalizers';
import { integerRegExp } from 'utils/patterns';
import { getModelPermission } from 'utils/permission';
import JornadaDetalle from './JornadaDetalle';

export const jornadaPermission = {
  permissionModel: 'jornada',
  catalogsModels: [],
  tabsModels: [],
};
const { TabPane } = Tabs;
const Jornada = ({ permission }) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [tiposJornadasNominas, setTiposJornadasNominas] = useState([]);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [, setConfirmationVisibleEstatus] = useState(false);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [selectedData] = useState({});

  const formInstances = [
    form,
    formDatos,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getJornadas();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _tiposJornadasNominas,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getTiposJornadasNominas(),
        getJornadas(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setTiposJornadasNominas(_tiposJornadasNominas);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setEstatusInactivo(false);
    setEstatusAutorizado(false);
    setCurrentTabKey('general');
    setSelectedRowKeys([]);
    setVisible(false);
    form.resetFields();
    formDatos.resetFields();
  };
  const onClickDeactivate = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      const values = data?.find((e) => e?.id === key);
      const vals = {
        ...values,
        is_active: false,
      };
      const saved = await patchJornada(key, vals);
      if (saved) {
        onSuccess(saved);
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  const onClickActivate = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      const values = data?.find((e) => e?.id === key);
      const vals = {
        ...values,
        is_active: true,
      };
      const saved = await patchJornada(key, vals);
      if (saved) {
        onSuccess(saved);
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _jornada = await getJornada(match.id);
    if (_jornada?.estados_globales === ESTATUS_ACTIVO
      || _jornada?.estados_globales === ESTATUS_INACTIVO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_INACTIVO
        || estado?.id === ESTATUS_ACTIVO));
    }
    if (_jornada?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_AUTORIZADO));
      setEstatusAutorizado(true);
    }
    if (_jornada?.estados_globales === ESTATUS_INACTIVO) {
      setEstatusInactivo(true);
    }

    if (_jornada) {
      form.setFieldsValue({
        ...formatReceived(_jornada),
        rango_hora_final: new
        Moment(_jornada.rango_hora_final, 'HH:mm:ss'),
        rango_hora_inicial: new
        Moment(_jornada.rango_hora_inicial, 'HH:mm:ss'),
      });
      formDatos.setFieldsValue(formatReceived(_jornada));
      setVisible(true);
      formatReceived(_jornada);
    }

    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };
      values.rango_hora_inicial = values.rango_hora_inicial.format('HH:mm:ss');
      values.rango_hora_final = values.rango_hora_final.format('HH:mm:ss');
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchJornada(key, values) : postJornada(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteJornada(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    setEstadosFiltered(estados);
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar La jornada ya autorizada');
        return;
      }
      const saved = await autorizarJornada(key);
      if (saved) {
        const _data = await getJornadas();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 400,
    },
    {
      titleText: 'Horas de la Jornada Semanal', // Título superior
      align: 'center',
      children: [
        {
          title: 'Desde',
          dataIndex: 'descripcion_hora_desde',
          key: 'descripcion_hora_desde',

          width: 100,
        },
        {
          title: 'Hasta',
          dataIndex: 'descripcion_hora_hasta',
          key: 'descripcion_hora_hasta',

          width: 100,
        },
      ],
    },
    {
      titleText: 'Rango de Horario Diario',
      width: 400,

      children: [
        {
          title: 'Hora Inicial',
          dataIndex: 'rango_hora_inicial',
          key: 'rango_hora_inicial',
          render: (val) => (val ? val?.format(TIME_FORMAT) : 'N/A'),

          width: 100,
        },
        {
          title: 'Hora Final',
          dataIndex: 'rango_hora_final',
          key: 'rango_hora_final',
          render: (val) => (val ? val?.format(TIME_FORMAT) : 'N/A'),

          width: 100,
        },
        {
          title: 'Jornada SAT',
          dataIndex: 'jornada_sat',
          key: 'jornada_sat',
          render: (val) => {
            const _tiposJornadasNominas = tiposJornadasNominas.find((e) => e.id === val);
            return `${_tiposJornadasNominas?.clave} - ${_tiposJornadasNominas?.descripcion}`;
          },
          width: 100,
        },

      ],
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    concepto: [requiredRule],
    horas: [
      requiredRule,
      {
        pattern: integerRegExp,
        validator: async () => {
          const { horas_en_jornada } = form.getFieldsValue();
          // eslint-disable-next-line no-restricted-globals
          if (isNaN(horas_en_jornada)) {
            throw new Error('Ingrese un valor válido');
          }
          if (horas_en_jornada > 24) {
            throw new Error('No se puede exceder el número de horas de un día');
          }
        },
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            data={data}
            cols={columns}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
              onClickActivate,
              onClickDeactivate,
            }}
            customActions={[
              {
                onClick: () => setConfirmationVisible(true),
                permission: { model: 'jornada', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                  // || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
              },
            ]}
            disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
            permission={permission}
            allowExportPDF={false}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Jornada`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"

              />
            )}
            bordered={false}
          >
            <Tabs
              onChange={setCurrentTabKey}
              activeKey={currentTabKey}
              type="card"
            >
              <TabPane
                tab="Jornada"
                key="general"
                forceRender
              >
                <Form
                  layout="vertical"
                  form={form}
                  name="general"
                  onFinish={() => onFinish()}
                  scrollToFirstError
                >
                  <Row gutter={10}>
                    {/* Fila principal con los tres campos */}
                    <Col xs={24} sm={8}>
                      <Form.Item
                        name="descripcion"
                        label="Descripción"
                        rules={rules.concepto}
                        hasFeedback
                      >
                        <Input
                          allowClear
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item
                        name="jornada_sat"
                        label="Jornada SAT"
                        rules={rules.required}
                        hasFeedback
                      >
                        <Select
                          labelProp="descripcion"
                          keyLabelRender
                          keyProp="clave"
                          dataSource={tiposJornadasNominas}
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item
                        name="estados_globales"
                        label="Estatus"
                        rules={rules.required}
                        hasFeedback
                        initialValue={1}
                      >
                        <Select
                          labelProp="descripcion"
                          keyProp="id"
                          dataSource={estadosFiltered}
                          disabled={!selectedRowKeys.length || estatusAutorizado || estatusInactivo}
                          onChange={(val) => {
                            if (val === ESTATUS_INACTIVO) {
                              setConfirmationVisibleEstatus(true);
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>

                    {/* Segunda fila completa: todo alineado horizontalmente */}
                    <Col xs={24}>
                      <Row gutter={10}>
                        {/* Número de Horas - Desde */}
                        <Col xs={24} sm={6}>
                          <Typography.Text strong>* Número de Horas de la Jornada Semanal</Typography.Text>
                          <Form.Item label="Desde" required>
                            <Input.Group compact>
                              <Form.Item
                                name="horas_desde"
                                rules={rules.required}
                                noStyle
                              >
                                <InputNumber
                                  min={1}
                                  max={50}
                                  style={{ width: '70%' }}
                                  disabled={estatusAutorizado || estatusInactivo}
                                />
                              </Form.Item>
                              <span style={{ marginLeft: 8 }}>horas</span>
                            </Input.Group>
                          </Form.Item>
                        </Col>

                        {/* Número de Horas - Hasta */}
                        <Col xs={24} sm={6}>
                          <Form.Item label="Hasta" required style={{ marginTop: 24 }}>
                            <Input.Group compact>
                              <Form.Item
                                name="horas_hasta"
                                rules={rules.required}
                                noStyle
                              >
                                <InputNumber
                                  min={1}
                                  max={50}
                                  style={{ width: '70%' }}
                                  disabled={estatusAutorizado || estatusInactivo}
                                />
                              </Form.Item>
                              <span style={{ marginLeft: 8 }}>horas</span>
                            </Input.Group>
                          </Form.Item>
                        </Col>

                        {/* Hora Inicial */}
                        <Col xs={24} sm={6}>
                          <Typography.Text strong>* Rango de Horario Diario</Typography.Text>
                          <Form.Item
                            label="Hora Inicial"
                            name="rango_hora_inicial"
                            rules={rules.required}
                            hasFeedback
                          >
                            <TimePicker
                              format="hh:mm A"
                              use24Hours
                              style={{ width: '100%' }}
                              disabled={estatusAutorizado || estatusInactivo}

                            />
                          </Form.Item>
                        </Col>

                        {/* Hora Final */}
                        <Col xs={24} sm={6}>
                          <Form.Item
                            label="Hora Final"
                            name="rango_hora_final"
                            rules={rules.required}
                            hasFeedback
                            style={{ marginTop: 24 }}
                          >
                            <TimePicker
                              format="hh:mm A"
                              use24Hours
                              style={{ width: '100%' }}
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                </Form>
                <JornadaDetalle
                  jornada={selectedRowKeys[0]}
                  permission={getModelPermission('jornadadetalle')}
                  hideParentForm={() => setVisible(false)}
                  showParentForm={() => setVisible(true)}
                />
              </TabPane>
            </Tabs>
          </Card>
        )}

        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`el Usuario ${form.getFieldValue('first_name')} ${form.getFieldValue('last_name')} ${form.getFieldValue('second_last_name') || ''}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar la Jornada ${form.getFieldValue('descripcion')}`}
          loading={loading}
        />

      </Spin>
    </Row>
  );
};

export default Jornada;
